app.controller('CheckoutDetailsController', [
  '$scope',
  'Config',
  '$timeout',
  'cart',
  'toaster',
  'product',
  'CacheFactory',
  'quote',
  '$window',
  '$location',
  '$anchorScroll',
  'setting',
  'helper',
  'userJourney',
  'bespoke',
  '$http',
  function ($scope, Config, $timeout, cart, toaster, product, CacheFactory, quote, $window, $location, $anchorScroll, setting, helper, userJourney, bespoke, $http) {

    $scope.cart = cart.getCart();
    $scope.user_journey = userJourney.getJourney();
    $scope.base_url = Config.base_url;
    $scope.cartService = cart;
    $scope.bespoke = bespoke.getBespoke();
    $scope.showPoReference = false;
    $scope.sameTransportDates = false;

    $scope.insideWorkingHours = Config.insideWorkingHours;
    $scope.outsideWorkingHours = Config.outsideWorkingHours;
    // $scope.outsideWorkingHours = $.grep(Config.outsideWorkingHours, function(value) {
    //   return $.inArray(value, Config.insideWorkingHours.slice(1)) < 0;
    // })
    $scope.timeslots = [
      ...$scope.insideWorkingHours,
      ...$scope.outsideWorkingHours,
    ]
    
    $scope.transport = {
      delivery: {
        option: null,
        actual_timeslots: $scope.insideWorkingHours
      },
      collection: {
        option: null,
        actual_timeslots: $scope.outsideWorkingHours
      }
    }
    $scope.surcharges = null;

    //check if a contact message with cart content is requested and prefill cart and relevent details
    if (helper.getParameterByName('message-id') && helper.getParameterByName('token')) {
      cart.content = [];
      CacheFactory.get('appCache').removeAll();
      CacheFactory.get('appCache').put('hireDays', 8);
    }

    $scope.details = {
      name: (CacheFactory.get('appCache').get('quote')) ? CacheFactory.get('appCache').get('quote').name : '',
      telephone: (CacheFactory.get('appCache').get('quote')) ? CacheFactory.get('appCache').get('quote').telephone : '',
      company: (CacheFactory.get('appCache').get('quote')) ? CacheFactory.get('appCache').get('quote').company : '',
      email: (CacheFactory.get('appCache').get('quote')) ? CacheFactory.get('appCache').get('quote').email : '',
      deliveryPostcode: (CacheFactory.get('appCache').get('quote')) ? CacheFactory.get('appCache').get('quote').deliveryPostcode : (angular.isDefined(CacheFactory.get('appCache').get('bespoke')) && CacheFactory.get('appCache').get('bespoke').postcode) ? CacheFactory.get('appCache').get('bespoke').postcode : '',
      collectionPostcode: (CacheFactory.get('appCache').get('quote')) ? CacheFactory.get('appCache').get('quote').collectionPostcode : (angular.isDefined(CacheFactory.get('appCache').get('bespoke')) && CacheFactory.get('appCache').get('bespoke').postcode) ? CacheFactory.get('appCache').get('bespoke').postcode : '',
      // deliveryDate: (CacheFactory.get('appCache').get('bespoke')) ? moment(CacheFactory.get('appCache').get('bespoke').deliveryDate).toDate() : '',
      // collectionDate: (CacheFactory.get('appCache').get('bespoke')) ? moment(CacheFactory.get('appCache').get('bespoke').collectionDate).toDate() : '',
      deliveryDate: '',
      collectionDate: '',
      deliveryDateOpened: false,
      collectionDateOpened: false,
      hireDays: (CacheFactory.get('appCache').get('hireDays')) ? CacheFactory.get('appCache').get('hireDays') : 8,
      hireWeeks: (CacheFactory.get('appCache').get('hireWeeks')) ? CacheFactory.get('appCache').get('hireWeeks') : 1,
      deliveryDateOptions: {
        minDate: moment().add(1, 'days').toDate(),
        startingDay: 1,
        showWeeks: false
      },
      postcodeModifer: (CacheFactory.get('appCache').get('quote')) ? CacheFactory.get('appCache').get('quote').postcodeModifer : false,
      deliveryCost: 0,
      CollectionCOst: 0,
      collectionDateOptions: {
        minDate: moment().add(1, 'days').toDate(),
        startingDay: 1,
        showWeeks: false
      },
      limitations: '',
    }

    if(helper.getParameterByName('quote-id')){
      // $scope.retrieveQuote(helper.getParameterByName('quote-id'));
      var quoteID = helper.getParameterByName('quote-id');
      helper.showLoader();
      quote.retrieveQuote(quoteID,helper.getParameterByName('token')).then(function(response) {
      //if valid then retrive it
          if(helper.getParameterByName('token')!=$('#user_token').val()){
            location.reload();
          }else{
            helper.showLoader();
            //clear JS session & add quote to the session
            cart.content = [];
            CacheFactory.get('appCache').removeAll();
            var quoteRes = response.data;
  
            //set quote data
            $scope.quote = quoteRes;

            cart.setCart(quoteRes.cart);
            CacheFactory.get('appCache').put('retrievedQuote',true);
            CacheFactory.get('appCache').put('cart',cart);
            //if retrival coming from a remarketing campain then store that a click happened
            if(helper.getParameterByName('utm_term')){
                quote.updateUtmTerm(helper.getParameterByName('utm_term'),$scope.quote.webQuoteID);
            }
            (quoteRes)

                $scope.details.deliveryPostcode = quoteRes.deliveryPostcode.toUpperCase();
                $scope.details.collectionPostcode = quoteRes.collectionPostcode.toUpperCase();
                $scope.details.company = quoteRes.company;
                $scope.details.name = quoteRes.name;
                $scope.details.email = quoteRes.email;
                $scope.details.telephone = quoteRes.telephone;
                $scope.details.deliveryDate = moment.unix(quoteRes.deliveryDateTimestamp).toDate();
                $scope.details.collectionDate = moment.unix(quoteRes.collectionDateTimestamp).toDate();
                $scope.details.hireDays = quoteRes.hireDays,
                $scope.details.hireWeeks = Math.round(($scope.details.hireDays / 7) + 0.35);

                $scope.hireDays = quoteRes.hireDays;
                CacheFactory.get('appCache').put('details', $scope.details);
                CacheFactory.get('appCache').put('hireDays', $scope.details.hireDays);
                $scope.quote.retrievedQuote = true;

                cart.updateCart('checkout');
                $scope.setHirePeriod()

                if(moment($scope.details.deliveryDate).format('DD/MM/YYYY') == moment($scope.details.collectionDate).format('DD/MM/YYYY')){

                  if(quoteRes.transportOptions.delivery.install !== null){
                    $scope.transport.delivery.install = quoteRes.transportOptions.delivery.install;
                  }
                  if(quoteRes.transportOptions.delivery.installCost !== null){
                    $scope.transport.delivery.installCost = quoteRes.transportOptions.delivery.installCost;
                  }
                  if(quoteRes.transportOptions.collection.derig !== null){
                    $scope.transport.collection.derig = quoteRes.transportOptions.collection.derig;
                  }
                  if(quoteRes.transportOptions.collection.derigCost !== null){
                    $scope.transport.collection.derigCost = quoteRes.transportOptions.collection.derigCost;
                  }

                  if(quoteRes.transportOptions.delivery.timeStart !== null){
                    $scope.transport.delivery.timeStart = quoteRes.transportOptions.delivery.timeStart;
                  }
                  if(quoteRes.transportOptions.delivery.timeEnd !== null){
                    $scope.transport.delivery.timeEnd = quoteRes.transportOptions.delivery.timeEnd;
                  }
                  if(quoteRes.transportOptions.collection.timeStart !== null){
                    $scope.transport.collection.timeStart = quoteRes.transportOptions.collection.timeStart;
                  }
                  if(quoteRes.transportOptions.collection.timeEnd !== null){
                    $scope.transport.collection.timeEnd = quoteRes.transportOptions.collection.timeEnd;
                  }


                  $scope.transport = {
                    delivery: {
                      timeStart: $scope.transport.delivery.timeStart,
                      timeEnd: $scope.transport.delivery.timeEnd
                    },
                    collection: {
                      timeStart: $scope.transport.collection.timeStart,
                      timeEnd: $scope.transport.collection.timeEnd
                    },
                  }
                  CacheFactory.get('appCache').put('details_transport', $scope.transport);
              }
          }
  
        }, function(response) {
        if(response.status==406 || response.status==404){
  
            //if not then show an error
            // $scope.retrievedQuote = response.data;
            window.location = '/404';
          helper.hideLoader();
        }
      });
      
    }
    if (helper.getParameterByName('message-id') && helper.getParameterByName('token')) {
      helper.showLoader();
      cart.completeQuoteFromMessage(helper.getParameterByName('message-id'), helper.getParameterByName('token')).then(function (response) {
        //set cart
        cart.setCart(response.data.cart);
        //set customer details
        $scope.details.name = response.data.message.name;
        $scope.details.company = response.data.message.company;
        $scope.details.telephone = response.data.message.telephone;
        $scope.details.email = response.data.message.email_address;
        if (response.data.message.postcode) {
          $scope.details.deliveryPostcode = response.data.message.postcode;
          $scope.details.collectionPostcode = response.data.message.postcode;
          CacheFactory.get('appCache').put('messageToQuote', true);
          // $timeout(function () {
          //   $scope.init();
          // }, 300);
        }

      }, function (response) {
        console.log(response);
      });
    }

    //watch delivery and collection postcodes for changes in order to trigger the updatecart event which gets the carriage price modifiers in return
    $scope.$watch('[details.deliveryPostcode,details.collectionPostcode]', function (newVal, oldVal) {
      if (newVal !== oldVal && angular.isDefined($scope.details.deliveryPostcode) && angular.isDefined($scope.details.collectionPostcode) && $scope.details.deliveryPostcode.length > 0 && $scope.details.collectionPostcode.length > 0) {
        $scope.$broadcast('cartUpdated', 'yes');
      }
    }, true);

    $scope.disableDeliveryBasedonCutoff = function (modifiedPrices) {
      //disable dates based on cutoff time
      angular.forEach(modifiedPrices, function (mod, key) {

        var result = 0;
        var today = moment();
        var modifierDate = moment(parseInt(mod.timestamp));
        var min_date_offset_before = parseInt($('#min_date_offset_before').val());
        var min_date_offset_after = parseInt($('#min_date_offset_after').val());
        var cutoff_time = parseInt($('#cutoff_time').val());

        //check if delivery date is less than tomorrow then disable it before the cut off
        if (moment().format('H') < cutoff_time) {
          if (modifierDate.diff(today, 'days') < min_date_offset_before) {
            mod.enabled = false;
          } else {
            mod.enabled = true;
          }
          //and after the cut off disable tomorrow and the day after
        } else {
          if (modifierDate.diff(today, 'days') < min_date_offset_after) {
            mod.enabled = false;
          } else {
            mod.enabled = true;
          }
        }
      });
    }

    //function to check if the user details are filled or not
    $scope.isUserInfoFilled = function () {
      if ($scope.details.name != '' && $scope.details.telephone != '' && $scope.details.email != '' && $scope.details.deliveryPostcode != '' && $scope.details.collectionPostcode != '') {
        return true;
      } else {
        return false;
      }
    }

    $scope.showBacs = function(){
      var endDate = moment($scope.details.deliveryDate).toDate();
      var startDate = moment().toDate();
      var result = -1;
      var currentDate = startDate;
      
      //At least 3 working days away for bacs
      while (currentDate <= endDate)  {  
        var weekDay = currentDate.getDay();
        if(weekDay != 0 && weekDay != 6) 
          result++;
         currentDate.setDate(currentDate.getDate()+1); 
      }
    
      if(result >= 3 && $scope.details.company != ''){
        $scope.showPoReference = true;
      }
      else {
        $scope.showPoReference = false;
      }
    }


    $scope.init = function (form) {
      cart.updateCart('checkout');
      $('#detailsForm').keydown(function (event) {
        if (event.keyCode == 13) {
          event.preventDefault();
          return false;
        }
      });

      //clear delivery checklist if already saved
      if (CacheFactory.get('appCache').get('checklistSaved')) {
        CacheFactory.get('appCache').remove('checklistSaved');
      }

      if(
          !angular.isDefined(CacheFactory.get('appCache').get('quote')) && 
          angular.isDefined(CacheFactory.get('appCache').get('bespoke')) && 
          (CacheFactory.get('appCache').get('bespoke').deliveryDate) &&
          (CacheFactory.get('appCache').get('bespoke').collectionDate)   
      ) {
        $scope.details.deliveryDate = moment($scope.bespoke.deliveryDate).toDate()
        $scope.details.collectionDate = moment($scope.bespoke.collectionDate).toDate()
        $scope.setHirePeriod();
      } 

      $scope.userForm = form;
      //get brand setting
      var hour;
      setting.get().then(function (response) {
        //set min delivery and collection dates based on saved cut-off time
        //retrieve 2 digit current hour value from the server
        setting.getTime().then(function (resp) {
            hour = resp.data.hour_24;
            if (hour >= parseInt(response.data.global.cutoff_time)) {
              $scope.details.deliveryDateOptions.minDate = moment(resp.data.datetime).add(parseInt(response.data.global.min_date_offset_after), 'days').toDate();
              if($scope.details.deliveryDate == ''){
                $scope.details.deliveryDate = (CacheFactory.get('appCache').get('deliveryDate')) ? moment(CacheFactory.get('appCache').get('deliveryDate')).toDate() : moment(resp.data.datetime).add(parseInt(response.data.global.min_date_offset_after), 'days').toDate();
              }
              $scope.details.collectionDateOptions.minDate = moment(resp.data.datetime).add(parseInt(response.data.global.min_date_offset_after) + 2, 'days').toDate();
              if($scope.details.collectionDate == '') {
                $scope.details.collectionDate = (CacheFactory.get('appCache').get('collectionDate')) ? moment(CacheFactory.get('appCache').get('collectionDate')).toDate() : moment(resp.data.datetime).add(parseInt(response.data.global.min_date_offset_after) + 7, 'days').toDate();
                $scope.details.collectionDateOptions.minDate = moment($scope.details.deliveryDate).toDate();
              }

            } else {
              $scope.details.deliveryDateOptions.minDate = moment(resp.data.datetime).add(parseInt(response.data.global.min_date_offset_before), 'days').toDate();

              if($scope.details.deliveryDate == ''){
                $scope.details.deliveryDate = (CacheFactory.get('appCache').get('deliveryDate')) ? moment(CacheFactory.get('appCache').get('deliveryDate')).toDate() : moment(resp.data.datetime).add(parseInt(response.data.global.min_date_offset_before), 'days').toDate();
              }

              $scope.details.collectionDateOptions.minDate = moment(resp.data.datetime).add(parseInt(response.data.global.min_date_offset_before) + 1, 'days').toDate();
              if($scope.details.collectionDate == '') {
                $scope.details.collectionDate = (CacheFactory.get('appCache').get('collectionDate')) ? moment(CacheFactory.get('appCache').get('collectionDate')).toDate() : moment(resp.data.datetime).add(parseInt(response.data.global.min_date_offset_before) + 7, 'days').toDate();
              }
            }
            //if user is coming from the instant quote page then trigger the modifiers
            //and set that check to false
            if (CacheFactory.get('appCache').get('instantQuote') || CacheFactory.get('appCache').get('retrievedQuote') || CacheFactory.get('appCache').get('messageToQuote')) {
              CacheFactory.get('appCache').put('instantQuote', false);
              CacheFactory.get('appCache').put('retrievedQuote', false);
              CacheFactory.get('appCache').put('messageToQuote', false);
              // $scope.getModifiers();
            }
        $scope.checkHirePeriod();

          })
          .catch(function (error) {
            console.log(error);
            // hour = (moment.utc().isDST()) ? moment.utc().utcOffset(60).hour() : moment.utc().hour();
          });
        helper.hideLoader();
      }, function (response) {

      });

      $scope.checkHirePeriod();
      

    }

    $scope.copyPostcode = function (event) {
      $scope.details.collectionPostcode = $scope.details.deliveryPostcode;
      $scope.handleSurcharges(true);
    }

    $scope.setCol = function () {
      $scope.details.collectionDate = new Date($scope.details.deliveryDate.getFullYear(), $scope.details.deliveryDate.getMonth(), $scope.details.deliveryDate.getDate());
      $scope.details.collectionDate = moment($scope.details.collectionDate).add(1, 'days').toDate();
      $scope.details.collectionDateOptions.minDate = $scope.details.deliveryDate;
      $scope.details.collectionDateOpened = true;
      $scope.setHirePeriod();
    }

    $scope.setHirePeriod = function () {
      deliveryDate = new Date($scope.details.deliveryDate.getFullYear(), $scope.details.deliveryDate.getMonth(), $scope.details.deliveryDate.getDate());
      collectionDate = new Date($scope.details.collectionDate.getFullYear(), $scope.details.collectionDate.getMonth(), $scope.details.collectionDate.getDate());
      $scope.details.hireDays = helper.hireDays(deliveryDate, collectionDate);

      if ($scope.details.hireDays == 1) {
        $scope.details.hireWeeks = 1;
      } else {
        $scope.details.hireWeeks = Math.round(($scope.details.hireDays / 7) + 0.35);
      }
      CacheFactory.get('appCache').put('hireDays', $scope.details.hireDays);
      CacheFactory.get('appCache').put('hireWeeks', $scope.details.hireWeeks);
      CacheFactory.get('appCache').put('deliveryDate', moment($scope.details.deliveryDate).utc());
      CacheFactory.get('appCache').put('collectionDate', moment($scope.details.collectionDate).utc());
      $scope.cartService.updateCart();
      $scope.showBacs()
      $scope.checkHirePeriod();
    }

    $scope.open = function (field) {
      if (field == 'col') {
        $scope.details.collectionDateOpened = true;
      } else {
        $scope.details.deliveryDateOpened = true;
      }
    }

    $scope.remove = function (idx) {
      var product_name = $scope.cart.content[idx].data.product_name;
      cart.remove(idx, 'checkout');
      toaster.pop('success', "Quote Updated!", product_name + ' removed successfully from quote!');
    }

    $scope.getQuote = function (type) {

      $scope.details.limitations = '';

      if (angular.isDefined($scope.userForm) && $scope.userForm.$valid) {
        helper.showLoader();
        var delivery_date_offset = 0;
        var collection_date_offset = 0;
        var content = angular.copy(CacheFactory.get('appCache').get('cart').content);

        //go through cart and add the full link for product images
        angular.forEach(content, function (item, key) {
          item.data.image = item.data.image;
        });
        var journey_data = null;

        
        $http({
					method: 'POST',
					data: {data: $scope.user_journey},
					url: Config.base_url+'contactus/save_journey_and_source'
					}).then(function(journey_res) {
						if(journey_res.data.status=="success"){
              var journey_and_source = journey_res.data.data;
							journey_data = {
								'user-journey-id':journey_and_source.user_journey_id,
								'came-from':journey_and_source.camefrom,
								'utm-campaign':journey_and_source.utm_campaign,
								'utm-medium':journey_and_source.utm_medium,
								'utm-source':journey_and_source.utm_source
							}



        data = {
          'brand': Config.brand_key,
          'delivery-postcode': $scope.details.deliveryPostcode.toUpperCase(),
          'collection-postcode': $scope.details.collectionPostcode.toUpperCase(),
          'cart-total-weight': cart.totalWeight(),
          'product-total': cart.getCart().totals.productTotal,
          'company': $scope.details.company,
          'name': $scope.details.name,
          'email': $scope.details.email,
          'telephone': $scope.details.telephone,
          'hire-days': $scope.details.hireDays,
          'user-agent': angular.element('#user-agent').val(),
          'user-ip': angular.element('#ip').val(),
          'token': angular.element('#user_token').val(),
          'delivery-date-timestamp': moment($scope.details.deliveryDate).endOf('day').unix(),
          'collection-date-timestamp': moment($scope.details.collectionDate).endOf('day').unix(),
          'cart': content,
          'delivery-date-offset': delivery_date_offset,
          'collection-date-offset': collection_date_offset,
          'user-journey' : journey_data,
        };

        //check for applied discount codes
        if (angular.isDefined(CacheFactory.get('appCache').get('quote'))) {
          if (angular.isDefined(CacheFactory.get('appCache').get('quote').discountCode)) {
            data['discount-code'] = CacheFactory.get('appCache').get('quote').discountCode;
          }
        }

        if ($('#utm_source').val() != '') {
          data['utm_source'] = $('#utm_source').val();
        }

        if ($('#utm_medium').val() != '') {
          data['utm_medium'] = $('#utm_medium').val();
        }

        if ($('#utm_campaign').val() != '') {
          data['utm_campaign'] = $('#utm_campaign').val();
        }

        if ($('#camefrom').val() != '') {
          data['camefrom'] = $('#camefrom').val();
        }

        /*=================================================
         =            Save quote in php session            = 
         =================================================*/

        quote.saveSession(data).then(function (response) {
          //get the delivery and collection timestamps
          if($scope.sameTransportDates){
            data['delivery-date'] = moment($scope.details.deliveryDate).format('DD/MM/YYYY');
            data['collection-date'] = moment($scope.details.collectionDate).format('DD/MM/YYYY');
            data['transport_data'] = $scope.transport;
          }

          quote.get(data).then(function (response) {
            var dataObj = response.data;
            if (typeof dataObj.code === 'undefined') {

              data = response.data;



              //creating and caching date offset for correct countdown output
              data['server_date_offset'] = moment(data.current_time*1000).diff(new Date());
              CacheFactory.get('appCache').put('quote', data);

              /*==================================================================
              =            Google Analytics and adWords tracking code            =
              ==================================================================*/

              if (!angular.isDefined(CacheFactory.get('appCache').get('firstTime'))) {
                //$('#main').append('<div style="display:inline;"><img height="1" width="1" style="border-style:none;" alt="" src="//www.googleadservices.com/pagead/conversion/'+Config.google_conversion_id+'/?label='+Config.google_conversion_label+'&script=0"/></div>');
                goog_report_conversion();
                // ga('send', 'pageview', {
                //   page: '/success.html'
                // });
                gtag('event', 'page_view', {page_location: Config.base_url + 'success.html'});
                //bing trigger for analytics
                window.uetq = window.uetq || [];
                window.uetq.push({
                  'ea': 'web_quote'
                });
                CacheFactory.get('appCache').put('firstTime', false);
              }

              //redirect to the quote page
              if (type == 'submit') {
                $scope.cart.cartChanged = false;
                CacheFactory.get("appCache").put("cart", $scope.cart);
                if($scope.sameTransportDates){
                  CacheFactory.get("appCache").put("details_transport", response.data.transport_data);
                }
                else {
                  CacheFactory.get('appCache').remove('details_transport');
                }

                $window.location.href = $scope.base_url + 'checkout/quote';
                // console.log(data);
              } else {
                helper.hideLoader();
              }
            }
          }, function (response) {
            if (response.status == 406) {
              //then there are some limitations
              $scope.details.limitations = response.data.limitations.message;
              helper.hideLoader();
            }
          });
        }, function (response) {
          if (response.status == 406) {
            helper.hideLoader();
          }
        });
      }})

      } else {
        // scroll up to the details section
        angular.element('input.ng-invalid').first().focus();
        $location.hash('detailsForm');
        $anchorScroll();
      }
    }

    $scope.getSurcharges = async function(force = false) {
      if ($scope.surcharges == null || force) {
        const data = {
          brand: Config.brand_key,
          deliveryPostcode: $scope.details.deliveryPostcode,
          collectionPostcode: $scope.details.deliveryPostcode
        };
        
        try {
          const response = await quote.getSurcharges(data);
          $scope.surcharges = response.data;

          if(force){
            $scope.setTimeslots('delivery', $scope.surcharges);
            $scope.setTimeslots('collection', $scope.surcharges);
          }
          return response.data;
        } catch (error) {
          console.log(error);
          return null; 
        }
      }
    };

    $scope.handleSurcharges = function() {
      $scope.getSurcharges(true);
    }

    $scope.checkHirePeriod = async function() {
      var surcharges = await $scope.getSurcharges();
        if($scope.details.deliveryDate != "" && $scope.details.collectionDate != "") {
  
          if(angular.isDefined(CacheFactory.get('appCache').get('details_transport'))){
            $scope.transport = CacheFactory.get('appCache').get('details_transport');
            $scope.setTimeslots('delivery', $scope.surcharges, false);
            $scope.setTimeslots('collection', $scope.surcharges, false);
          }
          else {
            $scope.setTimeslots('delivery', $scope.surcharges);
            $scope.setTimeslots('collection', $scope.surcharges);
          }
  
          $scope.sameTransportDates = false;
          if(moment($scope.details.deliveryDate).format('DD/MM/YYYY') == moment($scope.details.collectionDate).format('DD/MM/YYYY')){
            $scope.sameTransportDates = true;
          }
        }

    }

    $scope.getEndSlot = function(type, val){
      $scope.setTimeslots(type, $scope.surcharges, false);
    }

    $scope.setTimeslots = function(type, surcharges, initial = true) {
      var code = type == 'delivery' ? 'DEL' : 'COL';
      var timeStartValue = null;
      if(initial){
        if(type == 'delivery'){
          $scope.transport[type].timeStart = '08:00';
        }
        else {
          $scope.transport[type].timeStart = '16:00';
        }
      }

      var inside = 'no';
      $scope.insideWorkingHours.forEach((function(value, idx) {
        if(value == moment($scope.transport[type].timeStart,'HH:mm').format('HH')){
          inside = 'yes'
        }
      }))
      
      var surcharge = surcharges[`${type}_surcharges`].find(surcharge => surcharge.carriage_surcharge_code == `${code}TIMED` && surcharge.inside_working_hours == inside);
      var formatted_value = (parseInt(moment($scope.transport[type].timeStart,'HH:mm').format('HH')));
      $scope.transport[type].timeEnd = moment(formatted_value,'HH:mm').add(surcharge.duration, 'hours').format('HH:mm');
      $scope.transport[type].option = surcharge;
      $scope.transport['delivery'].timeSlots = [...$scope.insideWorkingHours, ...$scope.outsideWorkingHours];
      $scope.transport['collection'].timeSlots = [...$scope.insideWorkingHours, ...$scope.outsideWorkingHours];

      if(inside == 'no'){
        $scope.transport[type].actual_timeslots = $scope.outsideWorkingHours;
      }
      else {
        $scope.transport[type].actual_timeslots = $scope.insideWorkingHours;
      }

      $scope.transport['delivery'].timeSlots = $scope.transport['delivery'].timeSlots.sort(function(a, b) { return a - b} );
      $scope.transport['collection'].timeSlots = $scope.transport['collection'].timeSlots.sort(function(a, b) { return a - b });

      if(type == 'delivery'){
        var deliveryTimeSlots = $scope.transport['delivery'].timeSlots;
        var collection_formatted_value = (parseInt(moment($scope.transport['collection'].timeStart,'HH:mm').format('HH')));
        var timeSlotLength = $scope.transport['delivery'].timeSlots.length;

        if(deliveryTimeSlots.indexOf(formatted_value) >= deliveryTimeSlots.indexOf(collection_formatted_value) || deliveryTimeSlots.indexOf(formatted_value + 1) >= deliveryTimeSlots.indexOf(collection_formatted_value)){
          var next_index = deliveryTimeSlots.indexOf(formatted_value) + 2;
          if(next_index >= timeSlotLength) next_index = 0;

          $scope.transport['collection'].timeStart = moment((deliveryTimeSlots[next_index]),'HH:mm').format('HH:mm');
          $scope.transport['collection'].timeEnd = moment(deliveryTimeSlots[next_index], 'HH:mm').add(surcharge.duration, 'hours').format('HH:mm')

          var collection_inside = 'no';
          var filteredInsideSlots = $scope.filterTimeSlots($scope.insideWorkingHours, $scope.transport['collection'].option?.duration || 2);
          filteredInsideSlots.forEach((function(value, idx) {
            if(value == moment($scope.transport['collection'].timeStart,'HH:mm').format('HH')){
              collection_inside = 'yes'
            }
          }))
          var collection_surcharge = surcharges[`collection_surcharges`].find(surcharge => surcharge.carriage_surcharge_code == `COLTIMED` && surcharge.inside_working_hours == collection_inside);
          var collection_value = (parseInt(moment($scope.transport['collection'].timeStart,'HH:mm').format('HH')));
          $scope.transport['collection'].timeEnd = moment(collection_value,'HH:mm').add(collection_surcharge.duration, 'hours').format('HH:mm');
          $scope.transport['collection'].option = collection_surcharge;
          
        }

      }


      
    }
    $scope.filterTimeSlots = function(slots,duration){
      var filteredSlots = [];
      //get highest number in array
      var newEnd = slots.slice(-1).pop() - duration;
      //loop through slots and only get numbers lower or equal to new end
      slots.forEach(function(slot) {
        if(slot<=newEnd){
          filteredSlots.push(slot);
        }
      });
    return filteredSlots;
  }

  $scope.isOptionValueDisabled = function(value) {
    var deliveryValue = parseInt(moment($scope.transport['delivery'].timeStart,'HH:mm').format('HH')) + 1;
    var collectionValue = parseInt(moment(value,'HH:mm').format('HH'));

    var timeslots = $scope.transport['collection'].timeSlots;
    var currentIndex = timeslots.indexOf(deliveryValue);
    var optionIndex = timeslots.indexOf(collectionValue);

    if(currentIndex >= optionIndex) return true;
   
    return false;
  }
    // **************************************************************************
    // COMMENTED OUT 22/07/2022 - bb4522bf203fe1b874da4df1f09eaeb0655f76e0 
    // This was causing problems with updating the product qtys when the retrieving quote was put in place
    // It was auto updating after every input offclick which was causing the user to wait long periods of time

    
    // $scope.$on("cartUpdated", function() {
    //   $scope.instantSaveQuote();
    // })


    // $scope.instantSaveQuote = function () {
    //   if ($scope.isUserInfoFilled()) {
    //     $scope.getQuote("instant");
    //   } else {
    //     helper.hideTransLoader();
    //   }
    // };

    // **************************************************************************


    // HIDDEN CLICK & COLLECT
    // $scope.openWeeklyDiscountPopup = function () {
    //   $('#weeklyDiscountModal').modal('show');
    // }

    // $scope.setClickAndCollect = function (postcode) {
    //   $scope.details.collectionPostcode = postcode;
    //   $scope.details.deliveryPostcode = postcode;
    //   $('#confirmModal').modal('toggle');
    //   $scope.$broadcast('cartUpdated', 'yes');
    // }
    // $scope.toggleModalConfirm = function () {
    //   $('#confirmModal').modal('toggle');
    // }
    // $scope.setConfirmModalPostcode = function (postcode, depotName, address1, address2) {
    //   $scope.modalDepotInfo = {
    //     name: depotName,
    //     postcode: postcode,
    //     address1: address1,
    //     address2: address2,
    //   }
    // }

  }
]);

app.filter('formatSlot', function() {
  return function(slots) {
      var filteredSlots = [];
      //loop through and return addresses with matching postcodes
      angular.forEach(slots, function(slot, key) {
                slot = moment(slot,"HH:mm").format("HH:mm");
                filteredSlots.push(slot);
      });
      return filteredSlots;
  };
});